import React from 'react';
import { Grid } from '@material-ui/core';
// app
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { MessageGroup, Message, MessageReceipt as MessageReceiptEntity, emptyMessage } from '../../entities/notification';
// containter
import Modal from '../../containers/Modal';

interface MessageReceiptProps {
  open: any;
  title: string;
  messageGroup: MessageGroup;
  messages: Message[];
  messageReceipt: MessageReceiptEntity;
  onClose(route?: string): void
}

const MessageReceipt: React.FC<MessageReceiptProps> = (props) => {

  const classes = useStyles({});

  const firstMessage = props.messages.length ? props.messages[0] : emptyMessage;

  return (
    <Modal
      open={props.open}
      title={props.title}
      onClose={props.onClose}
    >
      <Grid container spacing={2}>
        <Grid item xs={3} className={classes.title}>Group Id:</Grid>
        <Grid item xs={9}>{props.messageGroup.id}</Grid>

        <Grid item xs={3} className={classes.title}>Message Id:</Grid>
        <Grid item xs={9}>{firstMessage.id}</Grid>

        <Grid item xs={3} className={classes.title}>Message Sid:</Grid>
        <Grid item xs={9}>{props.messageReceipt.MessageSid}</Grid>

        <Grid item xs={3} className={classes.title}>Message Date:</Grid>
        <Grid item xs={9}>{props.messageReceipt.DateSent}</Grid>
        
        <Grid item xs={3} className={classes.title}>Message Status:</Grid>
        <Grid item xs={9}>{props.messageReceipt.Status}</Grid>

        <Grid item xs={3} className={classes.title}>Message:</Grid>
        <Grid item xs={9}>{props.messageReceipt.Body}</Grid>
      </Grid>
    </Modal>
  );
};
export default MessageReceipt;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      textAlign: "right",
      fontWeight: 'bold'
    }
  })
);



// WEBPACK FOOTER //
// ./src/components/campaign/MessageReceipt.tsx